import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 164 157"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M82 117.399c23.389 0 42.35-18.933 42.35-42.29 0-23.355-18.961-42.29-42.35-42.29S39.65 51.755 39.65 75.11c0 23.357 18.96 42.29 42.35 42.29"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M52.74 3.81a5 5 0 0 1-2.305 6.684A71.95 71.95 0 0 0 18.427 41.36 71.8 71.8 0 0 0 10.7 85.112a5 5 0 0 1-9.903 1.394A81.8 81.8 0 0 1 9.6 36.66 81.95 81.95 0 0 1 46.056 1.504a5 5 0 0 1 6.685 2.306m58.519 0a5 5 0 0 1 6.685-2.305A81.95 81.95 0 0 1 154.4 36.66a81.8 81.8 0 0 1 8.802 49.846 5 5 0 0 1-9.903-1.394 71.8 71.8 0 0 0-7.726-43.752 71.95 71.95 0 0 0-32.008-30.866 5 5 0 0 1-2.306-6.684M81.999 37.82c-20.634 0-37.35 16.702-37.35 37.29S61.366 112.398 82 112.398c20.635 0 37.351-16.701 37.351-37.29 0-20.587-16.716-37.29-37.35-37.29m-47.35 37.29c0-26.124 21.207-47.29 47.35-47.29 26.145 0 47.351 21.165 47.351 47.29 0 26.124-21.206 47.289-47.35 47.289s-47.35-21.165-47.35-47.29m-1.956 59.269a5 5 0 0 1 6.983-1.111A72.07 72.07 0 0 0 82 146.999a72.07 72.07 0 0 0 42.323-13.732 5 5 0 0 1 5.872 8.094A82.07 82.07 0 0 1 82 156.999a82.08 82.08 0 0 1-48.196-15.638 5 5 0 0 1-1.111-6.983",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }